import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';

import { IForm, IPaginatedTableResponse, ISortingModel, Pagination, TViewPortPolygon } from '../../models';
import { EntityFilters, PaginatedApiBaseService } from './paginated-api-base.service';

@Injectable({ providedIn: 'root' })
export class FormApiService extends PaginatedApiBaseService {
    private readonly baseUrl = '/forms';

    constructor() {
        super('formApi');
    }

    public getForms(): Observable<Array<IForm>> {
        const defaultSorting: ISortingModel<IForm> = {
            property: 'timestamp',
            direction: 'descending',
            order: 1,
        };

        return this.getApiUrl(this.baseUrl).pipe(
            this.paginatedHttpGet<IForm, IForm>(null, null, [defaultSorting], null, null, null),
            map((response) => response.data)
        );
    }

    public getFormsPaginated<TableModel>(
        pagination: Pagination,
        filters?: EntityFilters,
        sorting?: Array<ISortingModel<TableModel>>,
        filterPreset?: string,
        viewport?: TViewPortPolygon
    ): Observable<IPaginatedTableResponse<IForm>> {
        return this.getApiUrl(this.baseUrl).pipe(
            this.paginatedHttpGet<IForm, TableModel>(
                pagination,
                filters,
                sorting,
                filterPreset,
                viewport,
                null
            )
        );
    }

    public getForm(formId: string): Observable<IForm> {
        return this.getApiUrl(`${this.baseUrl}/${formId}`).pipe(
            mergeMap((url) => this.http.get<IForm>(url))
        );
    }
}
